module.exports = __webpack_public_path__ + "94ba7e044be8309d71c5fdab0cd80150.svg";